export default "__VITE_ASSET__0IkpEoS1__"